// SpecRef: ARCH-005
// Reference: docs/decisions/ARCH-005-ui-error-detection-resilience.md#10-dedicated-sentry-telemetry-for-empty-responses
// Dedicated Sentry warning event for empty array responses; distinct fingerprint enables per-endpoint alert rules.
import * as Sentry from '@sentry/react';

/**
 * Fires a dedicated Sentry warning event when an API endpoint returns an
 * empty array. The stable fingerprint lets teams configure per-endpoint
 * Sentry alert rules (Issue Alerts or Metric Alerts) independently of
 * schema validation errors.
 *
 * @param endpoint - API endpoint name (e.g. 'activeCases', 'surgeons')
 */
export const logEmptyResponseToSentry = (endpoint: string): void => {
  Sentry.captureMessage(`Empty response from ${endpoint} — no items returned`, {
    level: 'warning',
    tags: {
      emptyResponse: true,
      endpoint,
    },
    fingerprint: ['empty-response', endpoint],
  });
};
